// @ts-strict-ignore
import {
  CmsApiBlock,
  CmsApiBlockType,
} from 'modules/cms/api/types/CmsApiBlock';

const blocksWithBackground: CmsApiBlockType[] = [
  'FLASH_CARD_QUIZ',
  'TWO_TILES',
  'RANDOM_GRAD_PROGRAMS',
  'RECOMMENDED_ACTIONS',
  'RECOMMENDED_JOBS',
];

type Props = {
  block: CmsApiBlock;
  fullWidthLayout?: boolean;
};

export function getContentHasBackground({ block, fullWidthLayout }: Props) {
  return (
    (blocksWithBackground.includes(block.type) ||
      (block.type === 'SPLIT_CONTENT' &&
        block.data.appearance === 'OVERLAPPING') ||
      (block.type === 'THREE_STEP_CTA' &&
        ['One', 'Two', 'Three'].some(
          (step) =>
            block.data[`step${step}Url`] && block.data.imageSize === 'SMALL'
        ))) &&
    fullWidthLayout
  );
}
